import React from "react";
import { RotaButton } from "@teamrota/rota-design";

import { Action, Actions, Dialog, Heading, Message, Overlay } from "./styles";

export const ResultModal: React.FC<{
  message: string;
  isError: boolean;
  onDismiss: () => void;
}> = ({ message, isError, onDismiss }) => {
  const style = isError ? { color: "red" } : {};
  const emoji = isError ? "⚠️" : "✅";

  return (
    <Overlay onClick={onDismiss}>
      <Dialog
        role="dialog"
        aria-modal="true"
        aria-label="Action result"
        onClick={(event) => event.stopPropagation()}
      >
        <Heading style={style}>
          {emoji} {isError ? "Error" : "Success"}
        </Heading>

        <Message>{message}</Message>

        <Actions>
          <Action>
            <RotaButton onClick={onDismiss} size="large" variant="contained">
              OK
            </RotaButton>
          </Action>
        </Actions>
      </Dialog>
    </Overlay>
  );
};
